export const RESULTADO_POR_PLACA = () => `/resultado-por-placa`;
